export const AcceptedFile = [
  'jpeg',
  'gif',
  'png',
  'jfif',
  'jpg',
  'pdf',
  'doc',
  'docx',
];

export const AcceptedImage: any = ['jpeg', 'gif', 'png', 'jfif', 'jpg', 'webp'];

export const PAGINATION_SIZES = [5, 10, 20, 30];

export const Regex = {
  name: /^[a-zA-Z]|[ء-ي]$/,
};

